
'use strict';
const $e49248defcc53d4b$var$rows = 4;
const $e49248defcc53d4b$var$columns = 4;
let $e49248defcc53d4b$var$gameField = [];
let $e49248defcc53d4b$var$score = 0;
const $e49248defcc53d4b$var$cellScoreLimit = 2048;
const $e49248defcc53d4b$var$startButton = document.querySelector('.start');
const $e49248defcc53d4b$var$messageStart = document.querySelector('.message-start');
const $e49248defcc53d4b$var$winMessage = document.querySelector('.message-win');
const $e49248defcc53d4b$var$loseMessage = document.querySelector('.message-lose');
const $e49248defcc53d4b$var$gameScore = document.querySelector('.game-score');
/* event for start or restart button */ $e49248defcc53d4b$var$startButton.addEventListener('click', ()=>{
    if ($e49248defcc53d4b$var$startButton.innerHTML === 'Start') {
        $e49248defcc53d4b$var$messageStart.classList.add('hidden');
        $e49248defcc53d4b$var$startButton.classList.replace('start', 'restart');
        $e49248defcc53d4b$var$startButton.innerHTML = 'Restart';
        $e49248defcc53d4b$var$setNewGame();
    } else {
        $e49248defcc53d4b$var$resetGameField();
        $e49248defcc53d4b$var$winMessage.classList.add('hidden');
        $e49248defcc53d4b$var$loseMessage.classList.add('hidden');
        $e49248defcc53d4b$var$messageStart.classList.remove('hidden');
        $e49248defcc53d4b$var$startButton.classList.replace('restart', 'start');
        $e49248defcc53d4b$var$startButton.innerHTML = 'Start';
        $e49248defcc53d4b$var$score = 0;
        $e49248defcc53d4b$var$gameScore.innerText = $e49248defcc53d4b$var$score;
    }
});
/* events for arrow buttons */ document.addEventListener('keyup', (e)=>{
    if (e.code === 'ArrowLeft') {
        $e49248defcc53d4b$var$slideLeft();
        $e49248defcc53d4b$var$newFieldGeneretion();
    } else if (e.code === 'ArrowRight') {
        $e49248defcc53d4b$var$slideRight();
        $e49248defcc53d4b$var$newFieldGeneretion();
    } else if (e.code === 'ArrowUp') {
        $e49248defcc53d4b$var$slideUp();
        $e49248defcc53d4b$var$newFieldGeneretion();
    } else if (e.code === 'ArrowDown') {
        $e49248defcc53d4b$var$slideDown();
        $e49248defcc53d4b$var$newFieldGeneretion();
    }
    $e49248defcc53d4b$var$gameScore.innerText = $e49248defcc53d4b$var$score;
    if (!$e49248defcc53d4b$var$checkPossibleMovVerticaly() && !$e49248defcc53d4b$var$checkPossibleMovHorizontaly() && !$e49248defcc53d4b$var$isEmptyCell()) {
        $e49248defcc53d4b$var$isLose();
        // eslint-disable-next-line no-useless-return
        return;
    }
});
/* events for swipes */ let $e49248defcc53d4b$var$startX = 0;
let $e49248defcc53d4b$var$startY = 0;
let $e49248defcc53d4b$var$endX = 0;
let $e49248defcc53d4b$var$endY = 0;
const $e49248defcc53d4b$var$threshold = 30;
document.addEventListener('touchstart', (e)=>{
    $e49248defcc53d4b$var$startX = e.touches[0].clientX;
    $e49248defcc53d4b$var$startY = e.touches[0].clientY;
    $e49248defcc53d4b$var$endX = $e49248defcc53d4b$var$startX;
    $e49248defcc53d4b$var$endY = $e49248defcc53d4b$var$startY;
});
document.addEventListener('touchmove', (e)=>{
    $e49248defcc53d4b$var$endX = e.touches[0].clientX;
    $e49248defcc53d4b$var$endY = e.touches[0].clientY;
});
document.addEventListener('touchend', ()=>{
    const diffX = $e49248defcc53d4b$var$endX - $e49248defcc53d4b$var$startX;
    const diffY = $e49248defcc53d4b$var$endY - $e49248defcc53d4b$var$startY;
    if (Math.abs(diffX) < $e49248defcc53d4b$var$threshold && Math.abs(diffY) < $e49248defcc53d4b$var$threshold) return;
    if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) $e49248defcc53d4b$var$slideRight();
        else $e49248defcc53d4b$var$slideLeft();
    } else if (diffY > 0) $e49248defcc53d4b$var$slideDown();
    else $e49248defcc53d4b$var$slideUp();
    $e49248defcc53d4b$var$newFieldGeneretion();
    $e49248defcc53d4b$var$gameScore.innerText = $e49248defcc53d4b$var$score;
    if (!$e49248defcc53d4b$var$checkPossibleMovVerticaly() && !$e49248defcc53d4b$var$checkPossibleMovHorizontaly() && !$e49248defcc53d4b$var$isEmptyCell()) $e49248defcc53d4b$var$isLose();
});
/* set new game */ function $e49248defcc53d4b$var$setNewGame() {
    $e49248defcc53d4b$var$resetGameField();
    $e49248defcc53d4b$var$newFieldGeneretion();
    $e49248defcc53d4b$var$newFieldGeneretion();
}
/* new field generation */ function $e49248defcc53d4b$var$newFieldGeneretion() {
    const r = Math.floor(Math.random() * $e49248defcc53d4b$var$rows);
    const c = Math.floor(Math.random() * $e49248defcc53d4b$var$columns);
    if ($e49248defcc53d4b$var$gameField[r][c] === 0) {
        const newField = document.getElementById(r.toString() + '-' + c.toString());
        const valueNum = Math.random();
        if (valueNum < 0.9) newField.innerText = '2';
        else newField.innerText = '4';
        $e49248defcc53d4b$var$gameField[r][c] = +newField.innerText;
        // eslint-disable-next-line no-useless-return
        return;
    } else {
        if (!$e49248defcc53d4b$var$isEmptyCell()) return;
        $e49248defcc53d4b$var$newFieldGeneretion();
    }
}
/* reset game field */ function $e49248defcc53d4b$var$resetGameField() {
    $e49248defcc53d4b$var$gameField = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    const fieldCell = document.querySelectorAll('.field-cell');
    for (const cell of fieldCell){
        cell.innerText = '';
        cell.classList.value = '';
        cell.classList.add('field-cell');
    }
}
/* directions of moving for game field */ function $e49248defcc53d4b$var$slideUp() {
    for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
        let row = [
            $e49248defcc53d4b$var$gameField[0][c],
            $e49248defcc53d4b$var$gameField[1][c],
            $e49248defcc53d4b$var$gameField[2][c],
            $e49248defcc53d4b$var$gameField[3][c]
        ];
        row = $e49248defcc53d4b$var$shift(row);
        for(let r = 0; r < $e49248defcc53d4b$var$rows; r++){
            $e49248defcc53d4b$var$gameField[r][c] = row[r];
            const cell = document.getElementById(r.toString() + '-' + c.toString());
            const num = $e49248defcc53d4b$var$gameField[r][c];
            $e49248defcc53d4b$var$updateCell(cell, num);
        }
    }
}
function $e49248defcc53d4b$var$slideDown() {
    for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
        let row = [
            $e49248defcc53d4b$var$gameField[0][c],
            $e49248defcc53d4b$var$gameField[1][c],
            $e49248defcc53d4b$var$gameField[2][c],
            $e49248defcc53d4b$var$gameField[3][c]
        ];
        row.reverse();
        row = $e49248defcc53d4b$var$shift(row);
        row.reverse();
        for(let r = 0; r < $e49248defcc53d4b$var$rows; r++){
            $e49248defcc53d4b$var$gameField[r][c] = row[r];
            const cell = document.getElementById(r.toString() + '-' + c.toString());
            const num = $e49248defcc53d4b$var$gameField[r][c];
            $e49248defcc53d4b$var$updateCell(cell, num);
        }
    }
}
function $e49248defcc53d4b$var$slideRight() {
    for(let r = 0; r < $e49248defcc53d4b$var$rows; r++){
        let row = $e49248defcc53d4b$var$gameField[r];
        row.reverse();
        row = $e49248defcc53d4b$var$shift(row);
        row.reverse();
        $e49248defcc53d4b$var$gameField[r] = row;
        for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
            const cell = document.getElementById(r.toString() + '-' + c.toString());
            const num = $e49248defcc53d4b$var$gameField[r][c];
            $e49248defcc53d4b$var$updateCell(cell, num);
        }
    }
}
function $e49248defcc53d4b$var$slideLeft() {
    for(let r = 0; r < $e49248defcc53d4b$var$rows; r++){
        let row = $e49248defcc53d4b$var$gameField[r];
        row = $e49248defcc53d4b$var$shift(row);
        $e49248defcc53d4b$var$gameField[r] = row;
        for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
            const cell = document.getElementById(r.toString() + '-' + c.toString());
            const num = $e49248defcc53d4b$var$gameField[r][c];
            $e49248defcc53d4b$var$updateCell(cell, num);
        }
    }
}
/* moving of game field */ function $e49248defcc53d4b$var$shift(r) {
    let row = $e49248defcc53d4b$var$filterZero(r);
    for(let i = 0; i < row.length - 1; i++)if (row[i] === row[i + 1]) {
        row[i] *= 2;
        row[i + 1] = 0;
        $e49248defcc53d4b$var$score += row[i];
    }
    row = $e49248defcc53d4b$var$filterZero(row);
    while(row.length < $e49248defcc53d4b$var$columns)row.push(0);
    return row;
}
/* changes game field after each moving */ function $e49248defcc53d4b$var$updateCell(cell, num) {
    cell.innerText = '';
    cell.classList.value = '';
    cell.classList.add('field-cell');
    if (num > 0) {
        cell.innerText = num;
        if (num < $e49248defcc53d4b$var$cellScoreLimit) cell.classList.add("field-cell--" + +num.toString());
        else {
            cell.classList.add('field-cell--2048');
            $e49248defcc53d4b$var$isWinner();
        }
    }
}
function $e49248defcc53d4b$var$filterZero(row) {
    return row.filter((r)=>r);
}
/* check game field for empty cells */ function $e49248defcc53d4b$var$isEmptyCell() {
    for(let r = 0; r < $e49248defcc53d4b$var$rows; r++)for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
        if ($e49248defcc53d4b$var$gameField[r][c] === 0) return true;
    }
    return false;
}
/* appear winner message */ function $e49248defcc53d4b$var$isWinner() {
    $e49248defcc53d4b$var$winMessage.classList.remove('hidden');
}
/* appear lose message */ function $e49248defcc53d4b$var$isLose() {
    $e49248defcc53d4b$var$loseMessage.classList.remove('hidden');
}
/* check possible of horizontal moving */ function $e49248defcc53d4b$var$checkPossibleMovHorizontaly() {
    for(let r = 0; r < $e49248defcc53d4b$var$rows; r++)for(let c = 0; c < $e49248defcc53d4b$var$columns; c++){
        if ($e49248defcc53d4b$var$gameField[r][c] === $e49248defcc53d4b$var$gameField[r][c + 1]) return true;
    }
    return false;
}
/* merging of two rows */ function $e49248defcc53d4b$var$isMergingRow(r) {
    const row = $e49248defcc53d4b$var$filterZero(r);
    for(let i = 0; i < row.length - 1; i++){
        if (row[i] === row[i + 1]) return true;
    }
    return false;
}
/* check possible of vertical moving */ function $e49248defcc53d4b$var$checkPossibleMovVerticaly() {
    const arr = [];
    const result = [];
    for(let c = 0; c < $e49248defcc53d4b$var$columns; c++)arr.push([
        $e49248defcc53d4b$var$gameField[0][c],
        $e49248defcc53d4b$var$gameField[1][c],
        $e49248defcc53d4b$var$gameField[2][c],
        $e49248defcc53d4b$var$gameField[3][c]
    ]);
    arr.forEach((b)=>result.push($e49248defcc53d4b$var$isMergingRow(b)));
    return result.some((el)=>el);
}


//# sourceMappingURL=game_summatrix.8de1a5e8.js.map
